import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { QuoteBar } from './QuoteBar';
import { ScrollToTop } from './ScrollToTop';
import { TransitionProvider, Curtain } from './PageTransition';
import { GlobalStyles } from '../styles/GlobalStyles';
import { useScrollProgress, useCursorFollower } from '../hooks/useChromeFX';
import { color } from '../styles/tokens';

// Top-level shell for the V-Tech site. Drop this into your router as the element that
// wraps the page routes:
//
//   <Route element={<VtechLayout />}>
//     <Route path="/" element={<HomePage />} />
//     ...
//   </Route>
//
// Props:
//   stickyQuote  - show the sticky bottom quote bar (default true)
//   grain        - show the subtle film-grain overlay (default true)
export const VtechLayout = ({ stickyQuote = true, grain = true }) => {
  const progress = useScrollProgress();
  useCursorFollower();

  return (
    <div
      className="vt-scope"
      style={{
        position: 'relative',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: color.bg,
        color: color.text,
        overflowX: 'clip',
        fontFamily: "'IBM Plex Sans', system-ui, sans-serif",
        WebkitFontSmoothing: 'antialiased',
      }}
    >
      <GlobalStyles />
      <ScrollToTop />

      {/* scroll progress bar */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          height: 2,
          width: '100%',
          transform: `scaleX(${progress})`,
          transformOrigin: '0 50%',
          background: 'linear-gradient(90deg,#4d8dff,#7fb0ff)',
          zIndex: 200,
          pointerEvents: 'none',
        }}
      />

      {/* film grain overlay */}
      {grain && (
        <div
          aria-hidden="true"
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 150,
            pointerEvents: 'none',
            mixBlendMode: 'soft-light',
            opacity: 0.5,
            backgroundImage:
              "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='140' height='140'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
          }}
        />
      )}

      <TransitionProvider>
        <Curtain />

        <Header />

        <main style={{ flex: 1 }}>
          <Outlet />
        </main>

        <Footer />
        <QuoteBar enabled={stickyQuote} />
      </TransitionProvider>
    </div>
  );
};
